import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { TipoArquivoMultiselectModule } from '../../../tipos/components/multiselect';
import { UsuarioMultiselectModule } from '../../../../usuario/multiselect';

import { ArquicoCardFilterComponent } from './arquivo-card-filter.component';

@NgModule({
    imports: [
        SharedModule,
        TipoArquivoMultiselectModule,
        UsuarioMultiselectModule
    ],
    declarations: [
        ArquicoCardFilterComponent
    ],
    exports: [
        ArquicoCardFilterComponent
    ]
})
export class ArquicoCardFilterModule { }
